import { Ability, AbilityBuilder } from '@casl/ability';
import store from '../store/index';

// Defines how to detect object's type
function subjectName(item) {
  if (!item || typeof item === 'string') {
    return item;
  }
  return item.__type;
}

const ability = new Ability([], { subjectName });

let currentAuth;
store.subscribe(() => {
  const prevAuth = currentAuth;
  currentAuth = store.getState().user;

  if (prevAuth !== currentAuth && currentAuth.id) {
    ability.update(defineRulesFor(currentAuth));
  }
});

function defineRulesFor(auth) {
  const { can, rules, cannot } = AbilityBuilder.extract();
  auth.profiles[0].permissions.map((permission) => {
    can(permission.name, 'App');
  });

  auth.profiles[0].steps.map((step) => {
    can(`${step.status_id}`, 'App');
  });

  auth.profiles[0].nf_approval_permission.map((nf_approval) => {
    can(`${nf_approval.name}`, 'App');
  });

  return rules;
}

export default ability;
